export class Utils {
  static positiveValueOrZero(value: number): number {
    return value >= 0 ? value : 0;
  }

  static isEmptyObject(obj: object): boolean {
    for (const key in obj) return false;

    return true;
  }
}
